import type { DayHoursMode } from "Components/Shared/Inputs/OpeningHoursInput/DayHoursRow/types";
import type { DayHours } from "Types/OpeningHours";

export const getDayHoursMode = ({
  isOpenAllDay,
  isClosedAllDay,
}: DayHours): DayHoursMode => {
  if (isOpenAllDay) {
    return "openAllDay";
  }

  if (isClosedAllDay) {
    return "closedAllDay";
  }

  return "range";
};
